import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import {
    ConfigurationType,
    GetProductByIdApiV2Parameter,
    GetProductVariantChildApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { chain, LoadInventory } from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    variantId?: string;
    productId?: string;
    searchTerm?: string;
    validateProduct?: boolean;
    skipInventoryValidation?: boolean;
    denyFixedConfiguration?: boolean;
}
interface Props {
    apiParameter: GetProductByIdApiV2Parameter | GetProductVariantChildApiV2Parameter;
    variantChildren?: ProductModel[] | null;
    product?: ProductModel;
    productInfo?: ProductInfo;
}
type HandlerType = Handler<Parameter, Props>;
export const LoadPricing: HandlerType = async props => {
    const product = props.product;
    if (!product) {
        return;
    }
    props.productInfo = createFromProduct(product);
    let loadedPricing = false;
    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [props.productInfo],
            onComplete: realTimePricingProps => {
                if (realTimePricingProps.error) {
                    if (props.productInfo) {
                        props.productInfo.failedToLoadPricing = true;
                    }
                } else if (props.productInfo) {
                    props.productInfo.pricing = realTimePricingProps.apiResult?.realTimePricingResults?.find(
                        o => o.productId === product.id,
                    );
                }
                loadedPricing = true;
            },
        }));
    await waitFor(() => loadedPricing);
};
addToChainAfter(chain, LoadInventory, LoadPricing);